module.exports = __webpack_public_path__ + "static/media/calendar.c6378d0f.svg";